'use client'

import { useConversationContext } from '@marketplace-web/domain/core-conversation'

import { urlWithParams } from '@marketplace-web/shared/utils'
import { CREATE_BUNDLE_URL } from 'constants/routes'
import { Screen } from 'constants/tracking/screens'
import {
  ConversationActionButton,
  ConversationActionProps,
} from '@marketplace-web/domain/conversation-action'

import StartBundleButtonWrapper from '../StartBundleButtonWrapper'

type Props = ConversationActionProps

const UpdateBundle = ({ primary, title, inverse, theme, size }: Props) => {
  const { conversation } = useConversationContext()
  const transactionId = conversation?.transactionId
  const oppositeUserId = conversation?.oppositeUser?.id

  if (!oppositeUserId || !transactionId) return null

  const updateBundleUrl = urlWithParams(CREATE_BUNDLE_URL(oppositeUserId), {
    transacion_id: transactionId,
  })

  return (
    <StartBundleButtonWrapper url={updateBundleUrl} screen={Screen.MessageReply}>
      {({ onClick }) => (
        <ConversationActionButton
          size={size}
          text={title}
          theme={theme}
          primary={primary}
          inverse={inverse}
          onClick={onClick}
        />
      )}
    </StartBundleButtonWrapper>
  )
}

export default UpdateBundle
